




























































import { Component, Vue } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import DialogModal from "@/components/DialogModal.vue";

@Component({
  components: {
    VModal,
    ConfirmModal,
    DialogModal,
  },
})
export default class Modals extends Vue {
  openModal() {
    (this.$refs.modal as VModal).show();
  }

  async openConfirm() {
    await (this.$refs.confirmModal as ConfirmModal).confirm(
      "Dialogo da confermare"
    );
  }

  async openDialog() {
    await (this.$refs.dialogModal as DialogModal).dialog("Messaggio");
  }
}
